import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import {
  gAPI_Ingetration,
  gAPI_Property_List_By_Group,
  gAPI_Internal_Property_By_Id,
  dAPI_Delete_Ingetration,
  gAPI_Delete_Instagram_Ingetration_Group,
  dAPI_Delete_Instagram_Ingetration_Group,
  API_INSTAGRAM,
} from '../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import { faHandSpock } from '@fortawesome/free-regular-svg-icons';
import {
  faPalette,
  faLanguage,
  faLocationArrow,
  faComment,
} from '@fortawesome/free-solid-svg-icons';
import { faWpforms } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BubblePosition from './BubblePosition';
import Example from './Example';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../helpers/AxiosAPI';
import FacebookInfo from './FacebookInfo';
import PersistentMenuForm from './PersistentMenuForm';
import MultliLanguages from './MultliLanguages';
import LiveChat from './LiveChat';
import Features from './WhatsApp/Features';

function InstagramIntegrationList({ match, history, propertyId, locale }) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [persistentMenuVisible, setPersistentMenuVisible] = useState(false);
  const [languageVisible, setLanguageVisible] = useState(false);
  const [liveChatVisible, setLiveChatVisible] = useState(false);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const localeOptions = [
    { id: 'en_US', name: 'en-English', direction: 'ltr' },
    { id: 'es_ES', name: 'es-Español', direction: 'ltr' },
    { id: 'zh', name: 'zh-简体中文', direction: 'ltr' },
    { id: 'fr_FR', name: 'fr-français', direction: 'ltr' },
    { id: 'zh_HK', name: 'hk-繁体中文', direction: 'ltr' },
    { id: 'mi', name: 'mi-Maori', direction: 'ltr' },
    { id: 'id_ID', name: 'id-Bahasa Indonesia', direction: 'ltr' },
    { id: 'tl_PH', name: 'tl-Tagalog (Filipino)', direction: 'ltr' },
    { id: 'vi_VN', name: 'vi-vietnamese', direction: 'ltr' },
    { id: 'ko_KR', name: 'ko-한국인', direction: 'ltr' },
  ];
  const property = () => {
    setPropertyVisible(true);
    setPersistentMenuVisible(false);
    setLanguageVisible(false);
    setLiveChatVisible(false);
    setFeaturesVisible(false);
  };
  const persistentMenu = () => {
    setPropertyVisible(false);
    setPersistentMenuVisible(true);
    setLanguageVisible(false);
    setLiveChatVisible(false);
    setFeaturesVisible(false);
  };
  const setLanguage = () => {
    setPropertyVisible(false);
    setPersistentMenuVisible(false);
    setLanguageVisible(true);
    setLiveChatVisible(false);
    setFeaturesVisible(false);
  };
  const setLiveChat = () => {
    setPropertyVisible(false);
    setPersistentMenuVisible(false);
    setLanguageVisible(false);
    setLiveChatVisible(true);
    setFeaturesVisible(false);
  };
  const features = () => {
    setPropertyVisible(false);
    setPersistentMenuVisible(false);
    setLanguageVisible(false);
    setLiveChatVisible(false);
    setFeaturesVisible(true);
  };
  useEffect(() => {
    LoadIntegration();
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((res) => {
      console.log(res.data);
      setPropertyData(res.data);
    });
  }, [integrationId]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        console.log(res.data);
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  };
  const updateModel = integration
    ? {
        name: integration.name,
        propertyId: integration.properties[0],
        defaultLanguage: 'en-US',
        sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
        accessToken: integration.channelDetails.accessToken,
        userId: integration.channelDetails.userId,
        profile: integration.channelDetails.profile,
        instaName: integration.channelDetails.name,
        userName: integration.channelDetails.userName,
        userEmail: integration.channelDetails.userEmail,
        facebookId: integration.channelDetails.facebookId,
        facebookName: integration.channelDetails.facebookName,
        menuEnabled: integration.channelDetails.menuEnabled,
        persistentMenu: integration.channelDetails.persistentMenu,
        botSettings: { ...integration.botSettings },
        liveChatSetting: integration.liveChat,
      }
    : null;
  const saveIntegration = (data) => {
    const { list, name, botSetting, persistentMenu, liveChat } = data;
    if (botSetting) {
      updateModel.botSettings = botSetting;
    }
    if (list) {
      updateModel.propertyId = list;
    }
    if (name) {
      updateModel.name = name;
    }
    if (persistentMenu) {
      updateModel.persistentMenu = persistentMenu;
    }
    if (liveChat) {
      updateModel.liveChatSetting = liveChat;
    }

    //console.log('update', updateModel);

    //console.log(updateModel.persistentMenu);
    let MenuData = [];

    updateModel.persistentMenu.map((item, index) => {
      let MenuDataItem = [];
      item.callToActions.map((menu) => {
        if (menu.type === 'postback') {
          MenuDataItem.push({
            type: menu.type,
            title: menu.title,
            payload: menu.payLoad,
          });
        } else if (menu.type === 'web_url') {
          MenuDataItem.push({
            type: menu.type,
            title: menu.title,
            url: menu.url,
            webview_height_ratio: 'full',
          });
        }
      });
      if (updateModel.botSettings.multilingual === true) {
        MenuDataItem.push({
          title: 'Switch Language',
          type: 'postback',
          payload: 'switch_language',
        });
      }

      MenuData.push({
        locale: item.locale,
        composer_input_disabled: false,
        call_to_actions: MenuDataItem,
      });
    });
    //console.log(MenuData);

    AxiosAPI({
      method: 'put',
      url: `${API_INSTAGRAM}/${integration.id}?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(() => {
        let data = {
          persistent_menu: MenuData,
        };
        let getWelcome = {
          get_started: {
            payload: 'Welcome',
          },
        };
      });
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${
        integration.id
      }/?group_id=${getGroupID()}`,
    }).then((res) => {
      let updateRequest = {
        updater: 'dashboard',
      };
      AxiosAPI({
        method: 'delete',
        url: `${dAPI_Delete_Instagram_Ingetration_Group}/${integration?.channelDetails?.userId}`,
        data: updateRequest,
      })
        .then((result) => {
          toggle();
        })
        .catch((err) => {
          console.log('err', err);
        });
      AxiosPublicAPI({
        method: 'delete',
        url: `https://graph.instagram.com/v24.0/me/subscribed_apps?access_token=${integration?.channelDetails?.accessToken}`,
      })
        .then((result) => {
          toggle();
          //LoadIntegrations  ();
        })
        .catch((err) => {
          console.log('err', err);
        });
    });
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id="integration.select_properties" />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id="integration.select_properties_enabled" />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon simple-icon-game-controller`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => features()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the features you want enabled on the website
                            chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${persistentMenuVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faWpforms} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => persistentMenu()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Persistent Menu
                          </p>
                          <p className="mb-4 text-small">
                            Enable Persistent Menu in Instagram
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${languageVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLanguage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Language
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${liveChatVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faComment} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLiveChat()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Live Chat
                          </p>
                          <p className="mb-4 text-small">
                            Select the settings for the live chat
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <FacebookInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {persistentMenuVisible && (
                <Fragment>
                  <PersistentMenuForm
                    localeOptions={localeOptions}
                    integration={integration}
                    persistentMenus={integration.channelDetails.persistentMenu}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/Facebook_Menu.png" /> */}
                </Fragment>
              )}
              {languageVisible && (
                <Fragment>
                  <MultliLanguages
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                </Fragment>
              )}
              {liveChatVisible && (
                <Fragment>
                  <LiveChat
                    liveChatSettings={integration.liveChat}
                    propertyData={propertyData}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <Features
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(
  connect(mapStateToProps, {})(InstagramIntegrationList)
);
